export default [
    // packages ordered by priority
    "PFPF",
    "PFF",
    "HF",
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFPTTF",
    "PFTTF",
    "HTT",
    "HS",
    "PF",
    "PFP",

];
